import React, { useEffect, useRef, useState } from 'react';
import Divider from '@mui/material/Divider';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ContainedButton from '../Buttons/ContainedButton';
import { KeyboardArrowUp } from '@mui/icons-material';
import { Box, Checkbox, Chip, TextField, Typography } from '@mui/material';
import { compare } from './utils/comparer';
import { StyledMenu } from '../Menu/StyledMenu';

export default function PrimaryFilterAndSort({ primary_filter_name, formatted_json_data, complete_paginated_data, update_chart_with_filtered_data, selected_primary_names, set_selected_primary_names, update_filter_type }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const [page_with_found_index_with_data_indexes, set_page_with_found_index_with_data_indexes] = useState({});
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [empty_text, set_empty_text] = useState(true);

  const search_primary_filter_key_values = (text) => {
    text = text.trim();
    if (text === "") {
      set_empty_text(true);
    }
    else {
      set_empty_text(false);
    }
    const indexes_with_page_number_and_idxs = {};
    const pages = Object.keys(complete_paginated_data);
    // let brk = false;
    for (let page of pages) {
      const idxs = complete_paginated_data[page].indexes.keys();
      for (let idx of idxs) {
        if (idx?.toLowerCase().includes(text)) {
          const corresponding_indexes = complete_paginated_data[page].indexes.get(idx);
          if (indexes_with_page_number_and_idxs[page]) {
            indexes_with_page_number_and_idxs[page][idx] = corresponding_indexes;
          }
          else {
            indexes_with_page_number_and_idxs[page] = {
              [idx]: corresponding_indexes
            };
          }
        }
      }
    }
    set_page_with_found_index_with_data_indexes(indexes_with_page_number_and_idxs);
    console.log({ complete_paginated_data, indexes_with_page_number_and_idxs });
  };

  useEffect(() => {
    search_primary_filter_key_values("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const [selected_to_filter, set_selected_to_filter] = useState(complete_paginated_data);


  const handle_add_id_to_selected_2_filter = ({ page_with_found_index_with_data_indexes, page, primary_name }, is_checked) => {
    // console.log({ page_with_found_index_with_data_indexes });
    const found_primary_data_indexes = page_with_found_index_with_data_indexes[page][primary_name];
    set_selected_primary_names((prev) => {
      let temp = prev.slice();
      if (is_checked) {
        temp.push({
          [primary_name]: found_primary_data_indexes,
          primary_name,
          page
        });
      }
      else {
        // console.log(temp);
        // console.log(is_checked);
        temp = temp.filter(item => {
          // console.log(item.primary_name, primary_name);
          return item.primary_name !== primary_name;
        });
      }
      temp.sort(compare);
      // console.log({ temp });
      return temp;
    });
  };

  const handle_select_all_from_search_result = () => {
    Object.keys(page_with_found_index_with_data_indexes).forEach((page) => {
      Object.keys(page_with_found_index_with_data_indexes[page]).forEach((primary_name) => {
        handle_add_id_to_selected_2_filter({ page_with_found_index_with_data_indexes, page, primary_name, }, true);
      });
    });
  };

  // useEffect(() => {
  //   console.log({
  //     selected_primary_names,
  //     formatted_json_data
  //   });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selected_primary_names]);

  const clearFilter = () => {
    set_selected_primary_names([]);
    update_chart_with_filtered_data(complete_paginated_data);
  };

  const handle_apply_primary_filter = () => {
    console.log({ selected_primary_names });
    const total_items = selected_primary_names.length;
    if (total_items === 0) {
      update_chart_with_filtered_data(complete_paginated_data);
      return;
    }
    // const items_per_page = 8;
    // const total_pages = Math.ceil(total_items / items_per_page);
    const new_paginated_data = {};
    let current_index_in_the_page = 0;
    let current_page = 1;
    for (let item of selected_primary_names) {
      const item_arr = item[item.primary_name];
      const first_index = item_arr[0];
      const length = item_arr.length;
      const last_index = item_arr[length - 1];
      const selected_data = complete_paginated_data[item.page].data.slice(first_index, last_index + 1);
      if (!new_paginated_data[current_page]) {
        current_index_in_the_page = 0;
        new_paginated_data[current_page] = {
          indexes: new Map(),
          data: []
        };
      }
      if (new_paginated_data[current_page].indexes.size >= 8) {
        console.log("need to create new page now...");
        current_page++;
        new_paginated_data[current_page] = {
          indexes: new Map(),
          data: []
        };
      }
      for (let data of selected_data) {
        new_paginated_data[current_page].data.push(data);
        const indexes = new_paginated_data[current_page].indexes;
        const new_state_of_indexes = [...(indexes.get(item.primary_name) || []), current_index_in_the_page];
        new_paginated_data[current_page].indexes.set(item.primary_name, new_state_of_indexes);
        current_index_in_the_page++;
      }
      // console.log({ selected_data });
    }
    console.log({ new_paginated_data });
    update_chart_with_filtered_data(new_paginated_data);
    update_filter_type();
  };


  let timer = useRef(null);

  const [primary_search_text, set_primary_search_text] = useState('');

  const onPrimarySearchTextInput = (e) => {
    set_primary_search_text(e.target.value);
    if (timer.current) {
      clearTimeout(timer.current);
    }
    if (e.target.value === "") {
      set_page_with_found_index_with_data_indexes({});
      set_empty_text(true);
      return;
    };
    timer.current = setTimeout(() => {
      search_primary_filter_key_values(e.target.value.toLowerCase().trim());
    }, 1000);
  };

  return (
    <div>
      <ContainedButton
        id={`${primary_filter_name}-chart-filterer`}
        aria-controls={open ? `${primary_filter_name}-chart-filterer-menu` : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        disableElevation
        onClick={handleClick}
        endIcon={open ? <KeyboardArrowUp /> : <KeyboardArrowDownIcon />}
      >
        Primary Filter
      </ContainedButton>
      <StyledMenu
        id={`${primary_filter_name}-chart-filterer-menu`}
        MenuListProps={{
          'aria-labelledby': `${primary_filter_name}-chart-filterer`,
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Box className="max-w-[350px] overflow-x-scroll">
          <Box className={`flex gap-2 justify-center items-center flex-wrap my-1 max-h-28 overflow-scroll w-full`}>
            {
              selected_primary_names.slice(0, 4).map((obj, idx) =>
                <Chip
                  onDelete={(e) => {
                    handle_add_id_to_selected_2_filter({
                      page_with_found_index_with_data_indexes,
                      page: obj.page,
                      primary_name: obj.primary_name
                    });
                  }}
                  key={`selected_primary_names_${idx}_${obj.primary_name}_${obj.page}`}
                  label={obj.primary_name}
                />
              )
            }
            {
              selected_primary_names.length > 4 && "..."
            }
          </Box>
          <Typography className='uppercase text-lg font-semibold'>{primary_filter_name.split("_").join(" ")}</Typography>
          <Box className="flex justify-between items-center my-1">
            <Box className="my-2 flex-grow">
              <TextField
                value={primary_search_text}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                className='w-full'
                size='small'
                id={`Search ${primary_filter_name}`}
                label={`Search ${primary_filter_name}`}
                variant="outlined"
                onChange={onPrimarySearchTextInput} />
            </Box>
            {/* <Box>
              <ContainedButton>Add</ContainedButton>
            </Box> */}
          </Box>
          {
            !empty_text && Object.keys(page_with_found_index_with_data_indexes).length > 0 && <Typography className='my-1 px-1'>Similar {primary_filter_name.split("_").join(" ")}'s</Typography>
          }
          {
            !empty_text &&
            <Box className="p-1 max-h-32 overflow-scroll my-1 border">
              {
                Object.keys(page_with_found_index_with_data_indexes).map((page, idx) => <Box key={`page-${page}-${primary_filter_name}`}
                  className='p-2 rounded-sm my-1'>
                  <Box className="">
                    <p className='text-sm'>Page-{page}</p>
                    <Box>
                      {Object.keys(page_with_found_index_with_data_indexes[page]).map((primary_name, idx) =>
                        <Box className="my-1 flex justify-between items-center" key={`page-${page}-${primary_filter_name}-primary-${primary_name}`}>
                          <p>
                            {primary_name}
                          </p>
                          <Checkbox checked={selected_primary_names.some(item => item.primary_name === primary_name)} onChange={(e) => {
                            handle_add_id_to_selected_2_filter({ page_with_found_index_with_data_indexes, page, primary_name, }, e.currentTarget.checked);
                          }} />
                        </Box>
                      )}
                    </Box>
                    <Divider />
                  </Box>
                </Box>)
              }
            </Box>
          }
          {
            Object.keys(page_with_found_index_with_data_indexes).length > 0 &&
            <Box className="flex flex-end justify-between my-1">
              <Box className="ml-auto">
                <ContainedButton onClick={handle_select_all_from_search_result}>Select All</ContainedButton>
              </Box>
            </Box>
          }
          <Box className="flex flex-end justify-between my-1">
            {
              selected_primary_names.length > 0 &&
              <ContainedButton onClick={clearFilter}>Clear Filter</ContainedButton>
            }
            <Box className="ml-auto">
              <ContainedButton onClick={handle_apply_primary_filter}>Apply Filter</ContainedButton>
            </Box>
          </Box>
        </Box>
        {/* <Divider sx={{ my: 0.5 }} /> */}
      </StyledMenu>
    </div >
  );
}